
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/dienstleistungen",
      function () {
        return require("private-next-pages/[locale]/dienstleistungen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/dienstleistungen"])
      });
    }
  